/** Collapse whitespace and lowercase for tolerant text matching across viewers. */
export function normalizeViewerText(value: string) {
  return value.replace(/\s+/g, " ").trim().toLowerCase();
}
